module.exports = __webpack_public_path__ + "img/Zoriktuev.c8eba4cc.jpeg";